import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import MultiFactor from './scenes/MultiFactor';
import NewPassword from './scenes/NewPassword';

import { useAuth } from '@omnigenbiodata/ui';
import { AUTH_CHALLENGES } from '../../core/constants/aws.constant';

function Auth() {
  const { challengeName, resetStatus } = useAuth();
  const [resetCount, setResetCount] = useState(0);

  useEffect(() => {
    if (resetCount < 1) {
      resetStatus();
      setResetCount(resetCount + 1);
    }
  }, [resetStatus, resetCount]);

  if (challengeName === AUTH_CHALLENGES.MFA_SETUP || challengeName === AUTH_CHALLENGES.SOFTWARE_TOKEN_MFA) {
    return <MultiFactor />;
  }

  if (challengeName === AUTH_CHALLENGES.NEW_PASSWORD || challengeName === AUTH_CHALLENGES.NEW_PASSWORD_REQUIRED) {
    return <NewPassword />;
  }

  return <Outlet />;
}

export default Auth;
